export interface MutualFund {
    SymbolCode: string;
    ReutersCode: string;
    RoundDigits: number;
    IconUrl: string;
    FundNameE: string;
    FundNameA: string;
    CurrencyAbbreviationE: string;
    CurrencyAbbreviationA: string;
    ClosePrice: number;
    LastYearClosePrice: number;
    AnnualChange: number;
    AnnualChangePercentage: number;
    lastMonthClosePrice: number;
    LastMonthChange: number;
    LastMonthChangePercentage: number;
    selected: boolean;
}

export interface FundDetails {
    IconUrl: string;
    SymbolCode: string;
    ReutersCode: string;
    FundNameE: string;
    FundNameA: string;
    ClosePrice: number;
    CurencyID: CurencyID;
    AbbreviationE: string;
    AbbreviationA: string;
    RiskProfileEN: string;
    RiskProfileAR: string;
    FundTypeAR: string;
    FundTypeEN: string;
    ExpenseType: number;
    PercentValue: number;
    FixedValue: number;
    Maximum: number;
    Minimum: number;
    BuyMinimumCertificate: number;
    SellMinimumCertificate: number;
    SubscriptionFrequencyEn: string;
    SubscriptionFrequencyAr: string;
    RedemptionFrequencyEn: string;
    RedemptionFrequencyAr: string;
    AboutEn: string;
    AboutAr: string;
    PdfsUrls: string;
    PdfsUrlsList: string[];
    CutOffTime: string;
}

export enum CurencyID {
    EGP = 1,
    USD = 2
}

export interface FundPriceChart {
    Data: FundPriceChartData[]
    XAxis: string[]
    YAxis: number[]
}

export interface FundPriceChartData {
    ClosePrice: number;
    Date: String;
}

export enum AccountType {
    FUND = 3,
    BASIC = 0,
    MINOR = 1001
}
export interface FundType {
    Id: number;
    FundTypeAr: string;
    FundTypeEn: string;
    FundTypeArDes: string;
    FundTypeEnDes: string;
    RiskType: number;
    RiskNameAr: string;
    RiskNameEn: string;
    FundCount: number;
  }
